import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ServicePlanBillingPolicy } from 'src/features/servicePlanBillingPolicies/utils/types';

const RESOURCE = '/subscriptions/service-plan-item/:servicePlanItemId/service-plan-item-billing-policy/:billingPolicyId/';

type QueryFnType = typeof queryFn;

interface DTO {
    servicePlanItemId: string;
    billingPolicyId: string;
}
const queryFn = ({ servicePlanItemId, billingPolicyId }: DTO): Promise<ServicePlanBillingPolicy> => {
    return axios.get(formatResourcePath(RESOURCE, { servicePlanItemId, billingPolicyId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetServicePlanBillingPolicy,  RESOURCE as SERVICE_PLAN_BILLING_POLICY_RESOURCE };
